import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function FileloadingContentReducer(state = initialState.fileloadingContent, action: any) {
  switch (action.type) {
    case types.SAVE_FILELOADINGCONTENT_SUCCESS:
      return action.fileloadingContent;
    default:
      return state;
  }
}
